import { $admin } from "./api/admin";
import apiEndpoints from "@/constants/api-endpoints";

/**
 * Fetches customers from the api resource
 * @param {Object} params - Api params
 * @returns {Promise} APi response
 */
export const getCustomers = (params) => {
  return $admin.get(apiEndpoints.customers, { params });
};

/**
 * Sends a post request to create a new Customer
 * @param {Object} params - Api params new customer details
 * @returns {Promise} API response
 */
export const createCustomer = (params) => {
  return $admin.post(apiEndpoints.customers, params);
};

/**
 * Sends a put request to update existing Customer
 * @param {Object} params - Api params customer details
 * @returns {Promise} API response
 */
export const updateCustomer = (customerId, params) => {
  return $admin.put(`${apiEndpoints.customers}/${customerId}`, params);
};

/**
 * Get customer details from the api resource
 * @param {Object} params - Api params
 * @returns {Promise} APi response
 */
export const getCustomer = (customerId, params) => {
  return $admin.get(`${apiEndpoints.customers}/${customerId}`, { params });
};

/**
 * Get customer usages
 * @param {Object} params - Api params
 * @returns {Promise} API response
 */
export const getCustomerUsage = (customerId, params) => {
  return $admin.get(`${apiEndpoints.customers}/${customerId}/usage`, {
    params,
  });
};
